import React, { useEffect, useState } from "react";
import { Box, FormHelperText, FormLabel, OutlinedInput } from "@mui/material";
import DateRangePicker from "../../../../date-picker/date-range-picker";
import Departure from "./departure/departure";
import ProductTypeOption from "./productTypeOption/productTypeOption";
import Destination from "./destination/destination";
import HotelDetails from "./hotelDetails/hotelDetails";
import DeviationHotel from "./deviationHotel/hotel";
import commonUtilities from "utilities/common";
import { withLocalizer } from "utilities/withLocalizer";
import { CONSTANTS } from "utilities/constants";
import MultiSelectDropdown from "components/common/multiSelectAutocomplete/multiSelect";
import MultiSelectDeparture from "components/common/multiSelectAutocomplete/multiSelectDepartures";
import TravelersCount from "./travelersCount/travelersCount";
import { CONFIGURATION } from "utilities/configuration";

function CreateQuoteStepTwo(props) {

    const nightText = props.localize("qma-night");
    const [deviationCount, setDeviationCount] = useState(1);

    const [deviationCabins, setDeviationCabins] = useState([]);

    const [isDurationHidden, setDurationHidden] = useState(false);


    const { data, events, errors } = props;
    const { quote, currentStep, optionIndex, createOptionSource, 
        currentRoute, quoteData, quotesData, reviewQuoteIndex, isReQuote, isEdit, clearSelectedDate,flightsDates,deviationCruises,deviationHotels,deviationOptionIndex } = data;
    let productType = commonUtilities.getProductType(props);
    const isIQMUser = commonUtilities.isIQMUser();

    if (currentStep !== CONFIGURATION.QUOTE_WIZARD_STEP_OPTION_INFO_COLLECTION) {
        return null;
    }

    const renderOptionIndex = () => {
        if (createOptionSource && createOptionSource === CONSTANTS.MODAL && !isReQuote) {
            return currentRoute.split("/").includes(CONSTANTS.QUOTE)
                ? optionIndex + quoteData?.data?.quoteOptions?.length + 1
                : optionIndex + quotesData?.data?.quotes[reviewQuoteIndex]?.quoteOptions?.length + 1;
        } else if (createOptionSource && createOptionSource === CONSTANTS.MODAL && isReQuote) {
            return currentRoute.split("/").includes(CONSTANTS.QUOTE)
                ? optionIndex + quoteData?.data?.quoteOptions?.length
                : optionIndex + 1;
        }

        return optionIndex + 1;
    };

    const language = commonUtilities.getLanguage();

    return (
        <div className="row step-two">

            <div className="row option-heading margin-bottom-3x font-22">
                <div className="pull-left margin-right">
                    {props.localize("qma-option")}
                </div>

                <div className="pull-left">{renderOptionIndex()}</div>
            </div>

            <div className="row">
                <ProductTypeOption
                    productType={quote?.productTypes[optionIndex]}
                    deviationType={quote?.deviationTypes[deviationOptionIndex]}
                    isManualQuote={quote?.productTypes[optionIndex]?.isManualQuote}
                    handleStep2Data={events.handleStep2Data}
                    getDestinations={events.getDestinations}
                    resetStep2={events.resetStep2}
                    isClone={data?.isClone}
                    isEdit={isEdit}
                />
            </div>
            {productType?.productType?.code === "Deviation" ? (
                <>
                    <div className="row margin-top-3x responsive">
                        <div className="col-5 x-full">
                            <MultiSelectDropdown
                                deviationTypes={quote?.deviationTypes}
                                data={data}
                                error={errors?.destination}
                                handleStep2Data={events.handleStep2Data}
                                handleStep2DeviationData={events.handleStep2DeviationData}
                                onDestinationChange={events.onDestinationChange}
                                setDeviationCount={setDeviationCount}
                                deviationHotels={deviationHotels}
                                deviationCruises={deviationCruises}
                            />
                            <FormHelperText error={errors?.deviationError?.destination ? true : false}>
                                {errors?.deviationError?.destination?.trim()?.length > 0 &&
                                    errors?.deviationError?.destination}
                            </FormHelperText>
                        </div>

                        <div className="col-5 x-full">
                            <MultiSelectDeparture
                                deviationTypes={quote?.deviationTypes}
                                data={data}
                                error={errors?.destination}
                                errors={errors}
                                handleStep2Data={events.handleStep2Data}
                                handleStep2DeviationData={events.handleStep2DeviationData}
                                onDestinationChange={events.onDestinationChange}
                            />
                            <FormHelperText error={errors?.deviationError?.departure ? true : false}>
                                {errors?.deviationError?.departure?.trim()?.length > 0 &&
                                    errors?.deviationError?.departure}
                            </FormHelperText>
                        </div>
                    </div>
                    <div className="row margin-top">
                        <div className="col-5 x-full">
                            <DateRangePicker
                                data={data} 
                                errors={errors}
                                clearDateEvent={clearSelectedDate}
                                handleStep2DeviationDates={events.handleStep2DeviationDates} 
                                handleStep2Data={events.handleStep2Data}
                                setDurationHidden={setDurationHidden}
                                isDisabled={ !quote?.deviationTypes[deviationOptionIndex]?.departures?.length > 0}
                                onDateRangeChange={events.onDateRangeChange}
                            />
                        </div>

                        <div className={(isIQMUser ? "col-3-no-margin-r travelers-count " : "col-3-no-margin-r travelers-count travelers-count-margin ") + language }>
                            <TravelersCount
                                forDeviationOption={true}
                                deviationOptionIndex={deviationOptionIndex}
                                deviationTypes={quote?.deviationTypes}
                                errors={errors}
                                events={events}
                            />
                            
                        </div>


                        
                    </div>
                    <div className="row margin-top-3x">
                        {Array.from({ length: deviationCount }, (element, index) => index)?.map((item, index) => (
                            <div className={`${index > 0 ? "row margin-top-2x" : "row"}`} key={index}>
                                <div className={`${index > 0 ? "col-2 margin-top-2x" : "col-2"}`}>
                                    <DeviationHotel
                                        index={0 + index * 4}
                                        deviationIndex={index}
                                        deviationTypes={quote?.deviationTypes}
                                        deviationHotels={deviationHotels?.[index]?.length > 0 ? deviationHotels[index] : deviationHotels?.length > 0 ? deviationHotels : []}
                                        setDeviationCabins={setDeviationCabins}
                                        deviationCabins={deviationCabins}
                                        deviationCruises={deviationCruises}
                                        handleStep2DeviationData={events.handleStep2DeviationData}
                                        deviationProductType={"Hotel"}
                                        roomType="Room"
                                        data={data}
                                        events={events}
                                        title={"Hotel"}
                                        error={errors && errors?.product}
                                        errors={errors}
                                    />
                                </div>
                                <div className={`${index > 0 ? "col-2 margin-top-2x" : "col-2"}`}>
                                    <DeviationHotel
                                        index={1 + index * 4}
                                        deviationIndex={index}
                                        deviationTypes={quote?.deviationTypes}
                                        deviationHotels={deviationHotels?.[index]?.length > 0 ? deviationHotels[index] : deviationHotels?.length > 0 ? deviationHotels : []}
                                        setDeviationCabins={setDeviationCabins}
                                        deviationCabins={deviationCabins}
                                        deviationCruises={deviationCruises}
                                        handleStep2DeviationData={events.handleStep2DeviationData}
                                        deviationProductType={"Hotel"}
                                        roomType="Room"
                                        data={data}
                                        events={events}
                                        title={"Hotel"}
                                        error={errors && errors?.product}
                                        errors={errors}
                                    />

                                </div>
                                <div className={`${index > 0 ? "col-2 margin-top-2x" : "col-2"}`}>
                                    <DeviationHotel
                                        index={2 + index * 4}
                                        deviationIndex={index}
                                        deviationTypes={quote?.deviationTypes}
                                        deviationCruises={deviationCruises?.[index]?.length > 0 ? deviationCruises[index] : deviationCruises.length > 0 ? deviationCruises : []}
                                        setDeviationCabins={setDeviationCabins}
                                        deviationCabins={deviationCabins}
                                        handleStep2DeviationData={events.handleStep2DeviationData}
                                        deviationProductType={"Cruise"}
                                        roomType="Cabin"
                                        data={data}
                                        events={events}
                                        title={"Cruise"}
                                        error={errors && errors?.product}
                                        errors={errors}
                                    />


                                </div>
                                <div className={`${index > 0 ? "col-2 margin-top-2x" : "col-2"}`}>
                                    <DeviationHotel
                                        index={3 + index * 4}
                                        deviationIndex={index}
                                        deviationTypes={quote?.deviationTypes}
                                        deviationCruises={deviationCruises?.[index]?.length > 0 ? deviationCruises[index] : deviationCruises.length > 0 ? deviationCruises : []}
                                        setDeviationCabins={setDeviationCabins}                                        
                                        deviationCabins={deviationCabins}
                                        handleStep2DeviationData={events.handleStep2DeviationData}
                                        deviationProductType={"Cruise"}
                                        roomType="Cabin"
                                        data={data}
                                        events={events}
                                        title={"Cruise"}
                                        error={errors && errors?.product}
                                        errors={errors}
                                    />


                                </div>
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <div className="row margin-top-3x responsive">
                    <div className="row">
                        <div className="col-3">
                            <Destination
                                data={data}
                                error={errors?.destination}
                                handleStep2Data={events.handleStep2Data}
                                onDestinationChange={events.onDestinationChange}
                            />
                            <FormHelperText error={errors?.destination ? true : false}>
                                {errors?.destination?.trim().length > 0 &&
                                    errors?.destination}
                            </FormHelperText>
                        </div>
                        {productType?.productType?.code !== "Hotel" &&
                            (
                                <div className="col-3">
                                    <Departure
                                        data={data}
                                        error={errors?.departure}
                                        handleStep2Data={events.handleStep2Data}
                                        onDepartureChange={events.onDepartureChange}
                                    />
                                    <FormHelperText error={errors?.departure ? true : false}>
                                        {errors?.departure?.trim().length > 0 &&
                                            errors?.departure}
                                    </FormHelperText>
                                </div>
                            )}

                        {productType?.productType?.code !== "Hotel" && (
                            <div className="col-3">
                                    &nbsp;
                            </div>
                        )}
                    </div>
                    <div className="row">
                        <div className="col-5 x-full">
                            <Box>
                                <DateRangePicker
                                    data={data}
                                    errors={errors}
                                    clearDateEvent={clearSelectedDate}
                                    handleStep2Data={events.handleStep2Data} 
                                    onDateRangeChange={events.onDateRangeChange}
                                    setDurationHidden={setDurationHidden}
                                    isDisabled={ productType?.destination?.code === "" || (productType?.productType?.code !== "Hotel" && productType?.departure.code === "")  || 
                                    (productType?.productType?.code !== "Hotel" && !flightsDates?.data?.departureDate && !flightsDates?.data?.returnDate) }
                                />
                                {/* <FormHelperText error={errors?.date}>
                                    {errors?.date?.trim().length > 0 &&
                                        errors?.date}  hello world
                                </FormHelperText> */}
                            </Box>
                        </div>
                        <div className={(isIQMUser ? "col-3-no-margin-r travelers-count " : "col-3-no-margin-r travelers-count travelers-count-margin ") + language }>
                            <TravelersCount
                                forDeviationOption={false}
                                productType={productType}
                                errors={errors}
                                events={events}
                            />
                        </div>
                    </div>
                </div>
            )}
            {(productType?.productType?.code.toLowerCase() !== "flight" &&
                productType?.productType?.code.toLowerCase() !== "deviation") && (
                <div className="row margin-top-1x">
                    {(productType?.productType?.code.toLowerCase() == "package" && isIQMUser) ? <div>You can select up to 10 hotels.</div> : ""}
                    <HotelDetails
                        errors={errors}
                        data={data}
                        events={events}
                    />
                </div>
            )}
        </div>
    );
}

export default withLocalizer(CreateQuoteStepTwo);